import _ from 'lodash';
import { produce } from 'immer';
import Initialiser from 'initialiser';
import { logout } from 'ducks/modules/user';
import constants from 'utils/constants';
import api from 'utils/api';
import store from 'ducks/configureStore';
// import { ToTitleCase } from 'utils/strings';

// ACTION TYPES
const START_FETCH_INBOX = 'START_FETCH_INBOX';
const UPDATED_INBOX = 'UPDATED_INBOX';
const CLEAR_INBOX = 'CLEAR_INBOX';
const START_SEARCH_INBOX = 'START_SEARCH_INBOX';
const UPDATED_SEARCH_INBOX = 'UPDATED_SEARCH_INBOX';
const START_FETCH_MESSAGE = 'START_FETCH_MESSAGE';
const UPDATED_FETCH_MESSAGE = 'UPDATED_FETCH_MESSAGE';
const CLEAR_SELECTED_MESSAGE = 'CLEAR_SELECTED_MESSAGE';

// SYNC ACTION CREATORS
export function startFetchInbox() {
    return { type: START_FETCH_INBOX };
}
export function updatedInbox(inbox) {
    return { type: UPDATED_INBOX, inbox };
}
export function clearInbox() {
    return { type: CLEAR_INBOX };
}
export function startSearchInbox() {
    return { type: START_SEARCH_INBOX };
}
export function updatedSearchInbox(inbox) {
    return { type: UPDATED_SEARCH_INBOX, inbox };
}
export function startFetchMessage() {
    return { type: START_FETCH_MESSAGE };
}
export function updatedFetchMessage(message) {
    return { type: UPDATED_FETCH_MESSAGE, message };
}
export function clearSelectedMessage() {
    return { type: CLEAR_SELECTED_MESSAGE };
}

// ASYNC ACTION CREATORS
export function fetchInbox() {
    return async (dispatch) => {
        dispatch(startFetchInbox());
        const user = store.getState().user;
        // Prevent unauthorized errors while reviewing T&C
        if (!user.accepted_terms) {
            dispatch(updatedInbox([]));
            return;
        }
        try {
            const response = await api.fetchInbox(user);

            const updatedResponse = produce(response, (draft) => {
                if (user.source_type !== 'M') {
                    _.remove(draft, (m) => m.status !== 'APPROVED');
                }
                draft.forEach((res) => {
                    const parsedFee = Number(res.proposed_fee.replace(/\D+/, ''));
                    res.parsedFee = parsedFee;

                    if (!res.updated_at) {
                        res.last_update = {
                            seconds: res.timestamp.seconds,
                        };
                    } else {
                        res.last_update = {
                            seconds: res.updated_at.seconds,
                        };
                    }
                });
            });
            dispatch(updatedInbox(updatedResponse));
        } catch (err) {
            console.error('Error fetching inbox: ', err);
            if (err && err.status === constants.HttpCodes.UNAUTHORIZED) {
                return dispatch(logout(err.data === constants.ServerCodes.TOKEN_EXPIRED));
            } else if (err && err.status === constants.HttpCodes.FORBIDDEN) {
                dispatch(updatedInbox(403));
            } else if (err && err.status === constants.HttpCodes.BAD_REQUEST) {
                return Initialiser.history.replace('/notfound');
            } else if (err && err.status === constants.HttpCodes.INTERNAL_SERVER_ERROR) {
                dispatch(updatedInbox(500));
            } else {
                dispatch(updatedInbox([]));
            }
        }
    };
}

export function searchInbox(term) {
    return async (dispatch) => {
        dispatch(startSearchInbox());
        const user = store.getState().user;
        try {
            const response = await api.searchMessages(user, term);
            dispatch(updatedSearchInbox(response));
        } catch (err) {
            console.error('Error searching inbox: ', err);
            if (err && err.status === constants.HttpCodes.UNAUTHORIZED) {
                return dispatch(logout(err.data === constants.ServerCodes.TOKEN_EXPIRED));
            } else if (err && err.status === constants.HttpCodes.FORBIDDEN) {
                dispatch(updatedSearchInbox(403));
            } else if (err && err.status === constants.HttpCodes.BAD_REQUEST) {
                return Initialiser.history.replace('/notfound');
            } else if (err && err.status === constants.HttpCodes.INTERNAL_SERVER_ERROR) {
                dispatch(updatedSearchInbox(500));
            } else {
                dispatch(updatedSearchInbox([]));
            }
        }
    };
}

export function fetchMessage(recipient, id) {
    return async (dispatch) => {
        dispatch(startFetchMessage());
        try {
            const inbox = store.getState().messages.inbox;
            const response = await api.fetchMessage(recipient, id);

            const updatedResponse = produce(response, (draft) => {
                if (inbox.length > 0) {
                    const inboxMessage = inbox.find((m) => Number(m.id) === Number(id));
                    draft.country = inboxMessage.country;
                }
            });

            dispatch(updatedFetchMessage(updatedResponse));
        } catch (err) {
            console.error('Error fetching message: ', err);
            if (err && err.status === constants.HttpCodes.UNAUTHORIZED) {
                return dispatch(logout(err.data === constants.ServerCodes.TOKEN_EXPIRED));
            } else if (err && err.status === constants.HttpCodes.FORBIDDEN) {
                dispatch(updatedFetchMessage(403));
            } else if (err && err.status === constants.HttpCodes.BAD_REQUEST) {
                return Initialiser.history.replace('/notfound');
            } else if (err && err.status === constants.HttpCodes.INTERNAL_SERVER_ERROR) {
                dispatch(updatedFetchMessage(500));
            } else {
                dispatch(updatedFetchMessage([]));
            }
        }
    };
}

// REDUCER
export default function reducer(state = Initialiser.initialState.messages, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            case UPDATED_INBOX: {
                if (action.inbox > 0) {
                    draft.inbox = action.inbox;
                } else {
                    draft.inbox = action.inbox;
                }
                break;
            }
            case CLEAR_INBOX: {
                draft.inbox = [];
                break;
            }
            case UPDATED_SEARCH_INBOX: {
                if (action.inbox > 0) {
                    draft.searchResult = action.inbox;
                } else {
                    draft.searchResult = action.inbox;
                }
                break;
            }

            case UPDATED_FETCH_MESSAGE: {
                if (action.message) {
                    draft.selectedMessage = action.message;
                } else {
                    draft.selectedMessage = action.message;
                }
                break;
            }

            case CLEAR_SELECTED_MESSAGE: {
                draft.selectedMessage = {};
                break;
            }

            default:
                return draft;
        }
    });
}
